import basicRequest from "../../../core/redux/actions/request";

const PREFIX = "REPORT_JOBS_PERIOD";
const getState = (state) => state.report.jobsPeriod;

const { postPattern, isLoading, getError, getData, reset } = basicRequest(PREFIX, getState);

const statJobsPeriod = (id) => postPattern("react/report/v1/jobs/" + id, {});

export { statJobsPeriod, isLoading, getError, getData, reset };
